import { RefObject, useEffect } from 'react';

// `inert` cubre teclado y hit-test, que `pointer-events` no alcanza, y va por ref porque React 17 no reconoce el atributo
function useInertNodes(ref: RefObject<HTMLElement | null>, isInert: boolean, selector?: string): void {
  useEffect(() => {
    const root = ref.current;
    if (!root) return undefined;

    function applyInert(): void {
      const nodes: Element[] = selector ? Array.from(root.querySelectorAll(selector)) : [root];
      nodes.forEach((node) => {
        if (isInert) {
          node.setAttribute('inert', '');
        } else {
          node.removeAttribute('inert');
        }
      });
    }

    applyInert();

    if (!isInert || !selector) return undefined;

    // Lemonade monta su captura tras inicializar el store: sin observar el subárbol, el bloqueo se queda en los nodos que reemplaza
    const observer = new MutationObserver(applyInert);
    observer.observe(root, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, [isInert, ref, selector]);
}

export default useInertNodes;
